'use strict';

import EcsElement from '../../../components/ecs-element/EcsElement';
import { ELEMENT_STATE } from '@/constants/element/constants';

const elementGetters = {
  getRawElementsForInteraction: state => interaction => {
    let result = [];

    if (interaction && interaction.interactionId) {
      result = [...state.elements, ...state.history]
        .filter(el => el.interactionId === interaction.interactionId)
        .map(element => new EcsElement(element));
    }

    return result;
  },

  /**
   * Get all EcsElements for a given interactionId or interaction object
   * @param state
   * @returns interaction => [EcsElement]
   */
  getElementsForInteraction: state => interaction => {
    let elements = [];
    if (interaction) {
      let interactionId;
      if (typeof interaction === 'string') {
        interactionId = interaction;
      } else if (typeof interaction === 'object') {
        interactionId = interaction.interactionId;
      }

      elements = [...state.elements, ...state.history].filter(el => el.interactionId === interactionId);
    }

    // NOTE: Patch to filter the conferenced elements and return just one
    // ECS keeps several elements on conference which is pretty strange
    const isOnConference = element =>
      [ELEMENT_STATE.conferenced, ELEMENT_STATE.conferencedDiverted].includes(element.elementStateId);
    const unconferencedElements = elements.filter(element => !isOnConference(element));
    const conferencedElement = elements.find(isOnConference);
    elements = conferencedElement ? [conferencedElement, ...unconferencedElements] : unconferencedElements;

    return elements.map(element => new EcsElement(element));
  },

  /**
   * Gets an EcsElement for a given elementId.
   * @param state
   * @returns elementId => EcsElement || null
   */
  getElement: state => elementId => {
    const element = [...state.elements, ...state.history].find(el => el.elementId === elementId);
    return element ? new EcsElement(element) : null;
  },

  getElementAnsweredAt: state => elementId => {
    return state.elementAnsweredAt[elementId];
  },

  getElementIdsByInteractionId: (state, getters) => interactionId => {
    return getters.getElementsForInteraction(interactionId).map(el => el.elementId);
  }
};

export default {
  ...elementGetters
};
